import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./admin_login.css";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === "production" ? "" : "http://localhost:5000");

const ROLES = {
  SUPER_ADMIN: "SUPER ADMIN",
  ADMIN: "ADMIN",
  OTA_MANAGER: "OTA MANAGER",
  OTA_EXECUTIVE: "OTA EXECUTIVE",
  SALES_EXECUTIVE: "SALES EXECUTIVE",
  ONBOARDING_MANAGER: "ONBOARDING MANAGER",
  ONBOARDING_EXECUTIVE: "ONBOARDING EXECUTIVE",
};

const normalizeRole = (role) => {
  if (!role) return "";

  const upperRole = String(role).trim().toUpperCase();

  if (upperRole === "SUPER ADMIN") return ROLES.SUPER_ADMIN;
  if (upperRole === "ADMIN") return ROLES.ADMIN;
  if (upperRole === "OTA MANAGER") return ROLES.OTA_MANAGER;
  if (upperRole === "OTA EXECUTIVE") return ROLES.OTA_EXECUTIVE;
  if (upperRole === "SALES EXECUTIVE") return ROLES.SALES_EXECUTIVE;
  if (upperRole === "ONBOARDING MANAGER") return ROLES.ONBOARDING_MANAGER;
  if (upperRole === "ONBOARDING EXECUTIVE") return ROLES.ONBOARDING_EXECUTIVE;

  return upperRole;
};

const getRedirectPathByRole = (role) => {
  switch (role) {
    case ROLES.SUPER_ADMIN:
    case ROLES.ADMIN:
    case ROLES.OTA_MANAGER:
    case ROLES.OTA_EXECUTIVE:
    case ROLES.SALES_EXECUTIVE:
    case ROLES.ONBOARDING_MANAGER:
    case ROLES.ONBOARDING_EXECUTIVE:
      return "/HomePage";

    default:
      return "/HomePage";
  }
};

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();

    if (!trimmedEmail || !trimmedPassword) {
      alert("Please enter email/username and password.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: trimmedEmail,
          password: trimmedPassword,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "❌ Invalid username or password.");
      }

      const userRole = normalizeRole(data.user?.role);
      const username = data.user?.username || trimmedEmail;

      if (!userRole) {
        throw new Error("User role missing. Please contact admin.");
      }

      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("loggedInUser", username);
      localStorage.setItem("loggedInRole", userRole);
      localStorage.setItem("role", userRole);
      // Granular permissions from Settings' "Assign Additional
      // Permissions" table — this is what permissions.js reads on every
      // other page.
      localStorage.setItem("additionalPermissions", JSON.stringify(data.user?.additionalPermissions || []));

      alert(`✅ Welcome ${username}! Logged in as ${userRole}.`);

      navigate(getRedirectPathByRole(userRole));
    } catch (err) {
      console.error("Login error:", err);
      alert(err.message || "Login failed. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleSubmit}>
        <h2>REVX LOGIN</h2>

        <div className="input-group">
          <label>Email / Username</label>
          <input
            type="text"
            placeholder="Enter your email or username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
  <label>Password</label>

  <div className="password-wrapper">
    <input
      type={showPassword ? "text" : "password"}
      placeholder="Enter your password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      required
    />

    <button
  type="button"
  className="password-toggle-btn"
  onClick={() => setShowPassword((prev) => !prev)}
  aria-label={showPassword ? "Hide password" : "Show password"}
  title={showPassword ? "Hide password" : "Show password"}
>
  <span className="password-icon">
    {showPassword ? <FaEyeSlash /> : <FaEye />}
  </span>
</button>
  </div>
</div>

        <button type="submit" className="login-btn">
          Login
        </button>
      </form>

      <footer className="login-footer">
        © 2026 Developed by <span className="brand">Vaibhav Prajapati</span> at{" "}
        <span style={{ color: "green" }}>RevX Hospitality</span>
      </footer>
    </div>
  );
}

export default AdminLogin;
